import { render, staticRenderFns } from "./landing-section.vue?vue&type=template&id=1bd946dd&"
import script from "./landing-section.vue?vue&type=script&lang=ts&"
export * from "./landing-section.vue?vue&type=script&lang=ts&"
import style0 from "./landing-section.vue?vue&type=style&index=0&id=1bd946dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports